import { c as _c } from "react-compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type { DataTag, DefinedInitialDataOptions, DefinedUseQueryResult, MutationFunction, QueryClient, QueryFunction, QueryKey, UndefinedInitialDataOptions, UseMutationOptions, UseMutationResult, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import type { ConfirmWellnessPhotoCaptureRequest, DisplayComprehensiveLashBrowAnalysisResponse, DisplayComprehensiveTreatmentAnalysisResponse, DisplayFrontalFacialImage, DisplayFrontalFacialImageLashBrowValidation, DisplayFrontalFacialImageValidation, DisplayProfileFacialImageValidation, DisplayWellnessBodyPhotoValidation, ProblemDetails, RetrieveComprehensiveLashBrowAnalysisParams, RetrieveComprehensiveTreatmentAnalysisParams, SetAssessmentPhotoCaptureCompleteRequest, UploadFrontalFacialImageBody, UploadFrontalFacialImageResponse, UploadLashBrowEyeCropBody, UploadProfileFacialImageBody, UploadWellnessBodyPhotoBody, UploadWellnessBodyPhotoResponse, ValidateFrontalFacialImageRequest, ValidateProfileFacialImageRequest } from "../model";
import { retrieveData } from "../../custom-fetch";
import type { ErrorType, BodyType } from "../../custom-fetch";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & {
  queryKey: K;
} => {
  const result = {
    queryKey
  } as T & {
    queryKey: K;
  };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};
export const getUploadFrontalFacialImageUrl = (assessmentId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/platforms/${platformId}/frontal-facial`;
};

/**
 * @summary Upload a frontal facial image for an Ageless Assessment
 */
export const uploadFrontalFacialImage = async (assessmentId: string, platformId: string, uploadFrontalFacialImageBody?: UploadFrontalFacialImageBody, options?: Parameters<typeof retrieveData>[1]): Promise<UploadFrontalFacialImageResponse> => {
  const formData = new FormData();
  if (uploadFrontalFacialImageBody?.File !== undefined) {
    formData.append(`File`, uploadFrontalFacialImageBody.File);
  }
  return retrieveData<UploadFrontalFacialImageResponse>(getUploadFrontalFacialImageUrl(assessmentId, platformId), {
    ...options,
    method: "POST",
    body: formData
  });
};
export const getUploadFrontalFacialImageMutationKey = () => ["uploadFrontalFacialImage"] as const;
export const getUploadFrontalFacialImageMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof uploadFrontalFacialImage>>, TError, UploadFrontalFacialImageMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof uploadFrontalFacialImage>>, TError, UploadFrontalFacialImageMutationVariables, TContext> => {
  const mutationKey = getUploadFrontalFacialImageMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadFrontalFacialImage>>, UploadFrontalFacialImageMutationVariables> = props => {
    const {
      assessmentId,
      platformId,
      data
    } = props ?? {};
    return uploadFrontalFacialImage(assessmentId, platformId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UploadFrontalFacialImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFrontalFacialImage>>>;
export type UploadFrontalFacialImageMutationBody = BodyType<UploadFrontalFacialImageBody> | undefined;
export type UploadFrontalFacialImageMutationError = ErrorType<unknown>;
export type UploadFrontalFacialImageMutationVariables = {
  assessmentId: string;
  platformId: string;
  data?: BodyType<UploadFrontalFacialImageBody>;
};

/**
 * @summary Upload a frontal facial image for an Ageless Assessment
 */
export const useUploadFrontalFacialImage = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUploadFrontalFacialImageMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getUploadProfileFacialImageUrl = (assessmentId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/platforms/${platformId}/profile-facial`;
};

/**
 * @summary Upload a profile facial image for an Ageless Assessment
 */
export const uploadProfileFacialImage = async (assessmentId: string, platformId: string, uploadProfileFacialImageBody?: UploadProfileFacialImageBody, options?: Parameters<typeof retrieveData>[1]): Promise<UploadFrontalFacialImageResponse> => {
  const formData = new FormData();
  if (uploadProfileFacialImageBody?.File !== undefined) {
    formData.append(`File`, uploadProfileFacialImageBody.File);
  }
  return retrieveData<UploadFrontalFacialImageResponse>(getUploadProfileFacialImageUrl(assessmentId, platformId), {
    ...options,
    method: "POST",
    body: formData
  });
};
export const getUploadProfileFacialImageMutationKey = () => ["uploadProfileFacialImage"] as const;
export const getUploadProfileFacialImageMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof uploadProfileFacialImage>>, TError, UploadProfileFacialImageMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof uploadProfileFacialImage>>, TError, UploadProfileFacialImageMutationVariables, TContext> => {
  const mutationKey = getUploadProfileFacialImageMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadProfileFacialImage>>, UploadProfileFacialImageMutationVariables> = props => {
    const {
      assessmentId,
      platformId,
      data
    } = props ?? {};
    return uploadProfileFacialImage(assessmentId, platformId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UploadProfileFacialImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadProfileFacialImage>>>;
export type UploadProfileFacialImageMutationBody = BodyType<UploadProfileFacialImageBody> | undefined;
export type UploadProfileFacialImageMutationError = ErrorType<unknown>;
export type UploadProfileFacialImageMutationVariables = {
  assessmentId: string;
  platformId: string;
  data?: BodyType<UploadProfileFacialImageBody>;
};

/**
 * @summary Upload a profile facial image for an Ageless Assessment
 */
export const useUploadProfileFacialImage = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUploadProfileFacialImageMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getUploadLashBrowEyeCropUrl = (assessmentId: string, platformId: string, frontalFacialImageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/platforms/${platformId}/frontal-facial/${frontalFacialImageId}/lash-brow-eye-crop`;
};

/**
 * @summary Upload a separate, loosely-cropped eye-region image for a previously uploaded frontal facial image.
The crop is consumed only by lash/brow validation and analysis; the full-face frontal image remains
the display/transformation source.
 */
export const uploadLashBrowEyeCrop = async (assessmentId: string, platformId: string, frontalFacialImageId: string, uploadLashBrowEyeCropBody?: UploadLashBrowEyeCropBody, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const formData = new FormData();
  if (uploadLashBrowEyeCropBody?.File !== undefined) {
    formData.append(`File`, uploadLashBrowEyeCropBody.File);
  }
  return retrieveData<void>(getUploadLashBrowEyeCropUrl(assessmentId, platformId, frontalFacialImageId), {
    ...options,
    method: "POST",
    body: formData
  });
};
export const getUploadLashBrowEyeCropMutationKey = () => ["uploadLashBrowEyeCrop"] as const;
export const getUploadLashBrowEyeCropMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof uploadLashBrowEyeCrop>>, TError, UploadLashBrowEyeCropMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof uploadLashBrowEyeCrop>>, TError, UploadLashBrowEyeCropMutationVariables, TContext> => {
  const mutationKey = getUploadLashBrowEyeCropMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadLashBrowEyeCrop>>, UploadLashBrowEyeCropMutationVariables> = props => {
    const {
      assessmentId,
      platformId,
      frontalFacialImageId,
      data
    } = props ?? {};
    return uploadLashBrowEyeCrop(assessmentId, platformId, frontalFacialImageId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UploadLashBrowEyeCropMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLashBrowEyeCrop>>>;
export type UploadLashBrowEyeCropMutationBody = BodyType<UploadLashBrowEyeCropBody> | undefined;
export type UploadLashBrowEyeCropMutationError = ErrorType<unknown>;
export type UploadLashBrowEyeCropMutationVariables = {
  assessmentId: string;
  platformId: string;
  frontalFacialImageId: string;
  data?: BodyType<UploadLashBrowEyeCropBody>;
};

/**
 * @summary Upload a separate, loosely-cropped eye-region image for a previously uploaded frontal facial image.
The crop is consumed only by lash/brow validation and analysis; the full-face frontal image remains
the display/transformation source.
 */
export const useUploadLashBrowEyeCrop = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUploadLashBrowEyeCropMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRetrieveFrontalFacialImageUrl = (imageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}`;
};

/**
 * @summary Retrieve a frontal facial image by its ID
 */
export const retrieveFrontalFacialImage = async (imageId: string, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayFrontalFacialImage> => {
  return retrieveData<DisplayFrontalFacialImage>(getRetrieveFrontalFacialImageUrl(imageId), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveFrontalFacialImageQueryKey = (imageId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}`] as const;
};
export const getRetrieveFrontalFacialImageQueryOptions = <TData = Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveFrontalFacialImageQueryKey(imageId);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>> = ({
    signal
  }) => retrieveFrontalFacialImage(imageId, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: imageId !== null && imageId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveFrontalFacialImageQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>>;
export type RetrieveFrontalFacialImageQueryError = ErrorType<unknown>;
export function useRetrieveFrontalFacialImage<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError = ErrorType<unknown>>(imageId: string, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, Awaited<ReturnType<typeof retrieveFrontalFacialImage>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveFrontalFacialImage<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, Awaited<ReturnType<typeof retrieveFrontalFacialImage>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveFrontalFacialImage<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImage>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve a frontal facial image by its ID
 */

export function useRetrieveFrontalFacialImage(imageId, options, queryClient) {
  const $ = _c(6);
  let t0;
  if ($[0] !== imageId || $[1] !== options) {
    t0 = getRetrieveFrontalFacialImageQueryOptions(imageId, options);
    $[0] = imageId;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[3] !== query || $[4] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[3] = query;
    $[4] = queryOptions.queryKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export const getValidateFrontalFacialImageUrl = (imageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}/validate`;
};

/**
 * @summary Validate a frontal facial image for facial analysis
 */
export const validateFrontalFacialImage = async (imageId: string, validateFrontalFacialImageRequest?: ValidateFrontalFacialImageRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getValidateFrontalFacialImageUrl(imageId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(validateFrontalFacialImageRequest)
  });
};
export const getValidateFrontalFacialImageMutationKey = () => ["validateFrontalFacialImage"] as const;
export const getValidateFrontalFacialImageMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof validateFrontalFacialImage>>, TError, ValidateFrontalFacialImageMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof validateFrontalFacialImage>>, TError, ValidateFrontalFacialImageMutationVariables, TContext> => {
  const mutationKey = getValidateFrontalFacialImageMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateFrontalFacialImage>>, ValidateFrontalFacialImageMutationVariables> = props => {
    const {
      imageId,
      data
    } = props ?? {};
    return validateFrontalFacialImage(imageId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type ValidateFrontalFacialImageMutationResult = NonNullable<Awaited<ReturnType<typeof validateFrontalFacialImage>>>;
export type ValidateFrontalFacialImageMutationBody = BodyType<ValidateFrontalFacialImageRequest> | undefined;
export type ValidateFrontalFacialImageMutationError = ErrorType<unknown>;
export type ValidateFrontalFacialImageMutationVariables = {
  imageId: string;
  data?: BodyType<ValidateFrontalFacialImageRequest>;
};

/**
 * @summary Validate a frontal facial image for facial analysis
 */
export const useValidateFrontalFacialImage = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getValidateFrontalFacialImageMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getSetAssessmentPhotoCaptureCompleteUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/photo-capture-complete`;
};

/**
 * @summary Mark photo capture as complete for an assessment.
 */
export const setAssessmentPhotoCaptureComplete = async (assessmentId: string, setAssessmentPhotoCaptureCompleteRequest?: SetAssessmentPhotoCaptureCompleteRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentPhotoCaptureCompleteUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(setAssessmentPhotoCaptureCompleteRequest)
  });
};
export const getSetAssessmentPhotoCaptureCompleteMutationKey = () => ["setAssessmentPhotoCaptureComplete"] as const;
export const getSetAssessmentPhotoCaptureCompleteMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof setAssessmentPhotoCaptureComplete>>, TError, SetAssessmentPhotoCaptureCompleteMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof setAssessmentPhotoCaptureComplete>>, TError, SetAssessmentPhotoCaptureCompleteMutationVariables, TContext> => {
  const mutationKey = getSetAssessmentPhotoCaptureCompleteMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAssessmentPhotoCaptureComplete>>, SetAssessmentPhotoCaptureCompleteMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return setAssessmentPhotoCaptureComplete(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type SetAssessmentPhotoCaptureCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof setAssessmentPhotoCaptureComplete>>>;
export type SetAssessmentPhotoCaptureCompleteMutationBody = BodyType<SetAssessmentPhotoCaptureCompleteRequest> | undefined;
export type SetAssessmentPhotoCaptureCompleteMutationError = ErrorType<unknown>;
export type SetAssessmentPhotoCaptureCompleteMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentPhotoCaptureCompleteRequest>;
};

/**
 * @summary Mark photo capture as complete for an assessment.
 */
export const useSetAssessmentPhotoCaptureComplete = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getSetAssessmentPhotoCaptureCompleteMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRetrieveFrontalFacialImageValidationUrl = (imageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}/validation`;
};

/**
 * @summary Retrieve the validation result for a frontal facial image
 */
export const retrieveFrontalFacialImageValidation = async (imageId: string, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayFrontalFacialImageValidation> => {
  return retrieveData<DisplayFrontalFacialImageValidation>(getRetrieveFrontalFacialImageValidationUrl(imageId), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveFrontalFacialImageValidationQueryKey = (imageId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}/validation`] as const;
};
export const getRetrieveFrontalFacialImageValidationQueryOptions = <TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveFrontalFacialImageValidationQueryKey(imageId);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>> = ({
    signal
  }) => retrieveFrontalFacialImageValidation(imageId, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: imageId !== null && imageId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveFrontalFacialImageValidationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>>;
export type RetrieveFrontalFacialImageValidationQueryError = ErrorType<unknown>;
export function useRetrieveFrontalFacialImageValidation<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveFrontalFacialImageValidation<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveFrontalFacialImageValidation<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve the validation result for a frontal facial image
 */

export function useRetrieveFrontalFacialImageValidation(imageId, options, queryClient) {
  const $ = _c(6);
  let t0;
  if ($[0] !== imageId || $[1] !== options) {
    t0 = getRetrieveFrontalFacialImageValidationQueryOptions(imageId, options);
    $[0] = imageId;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[3] !== query || $[4] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[3] = query;
    $[4] = queryOptions.queryKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export const getRetrieveFrontalFacialImageLashBrowValidationUrl = (imageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}/lash-brow-validation`;
};

/**
 * @summary Retrieve the lash/brow validation result for a frontal facial image
 */
export const retrieveFrontalFacialImageLashBrowValidation = async (imageId: string, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayFrontalFacialImageLashBrowValidation> => {
  return retrieveData<DisplayFrontalFacialImageLashBrowValidation>(getRetrieveFrontalFacialImageLashBrowValidationUrl(imageId), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveFrontalFacialImageLashBrowValidationQueryKey = (imageId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/frontal-facial/${imageId}/lash-brow-validation`] as const;
};
export const getRetrieveFrontalFacialImageLashBrowValidationQueryOptions = <TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError = ErrorType<ProblemDetails>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveFrontalFacialImageLashBrowValidationQueryKey(imageId);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>> = ({
    signal
  }) => retrieveFrontalFacialImageLashBrowValidation(imageId, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: imageId !== null && imageId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveFrontalFacialImageLashBrowValidationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>>;
export type RetrieveFrontalFacialImageLashBrowValidationQueryError = ErrorType<ProblemDetails>;
export function useRetrieveFrontalFacialImageLashBrowValidation<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError = ErrorType<ProblemDetails>>(imageId: string, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveFrontalFacialImageLashBrowValidation<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError = ErrorType<ProblemDetails>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveFrontalFacialImageLashBrowValidation<TData = Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError = ErrorType<ProblemDetails>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveFrontalFacialImageLashBrowValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve the lash/brow validation result for a frontal facial image
 */

export function useRetrieveFrontalFacialImageLashBrowValidation(imageId, options, queryClient) {
  const $ = _c(6);
  let t0;
  if ($[0] !== imageId || $[1] !== options) {
    t0 = getRetrieveFrontalFacialImageLashBrowValidationQueryOptions(imageId, options);
    $[0] = imageId;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[3] !== query || $[4] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[3] = query;
    $[4] = queryOptions.queryKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export const getValidateProfileFacialImageUrl = (imageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/profile-facial/${imageId}/validate`;
};

/**
 * @summary Validate a profile facial image for facial analysis
 */
export const validateProfileFacialImage = async (imageId: string, validateProfileFacialImageRequest?: ValidateProfileFacialImageRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getValidateProfileFacialImageUrl(imageId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(validateProfileFacialImageRequest)
  });
};
export const getValidateProfileFacialImageMutationKey = () => ["validateProfileFacialImage"] as const;
export const getValidateProfileFacialImageMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof validateProfileFacialImage>>, TError, ValidateProfileFacialImageMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof validateProfileFacialImage>>, TError, ValidateProfileFacialImageMutationVariables, TContext> => {
  const mutationKey = getValidateProfileFacialImageMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateProfileFacialImage>>, ValidateProfileFacialImageMutationVariables> = props => {
    const {
      imageId,
      data
    } = props ?? {};
    return validateProfileFacialImage(imageId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type ValidateProfileFacialImageMutationResult = NonNullable<Awaited<ReturnType<typeof validateProfileFacialImage>>>;
export type ValidateProfileFacialImageMutationBody = BodyType<ValidateProfileFacialImageRequest> | undefined;
export type ValidateProfileFacialImageMutationError = ErrorType<unknown>;
export type ValidateProfileFacialImageMutationVariables = {
  imageId: string;
  data?: BodyType<ValidateProfileFacialImageRequest>;
};

/**
 * @summary Validate a profile facial image for facial analysis
 */
export const useValidateProfileFacialImage = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getValidateProfileFacialImageMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRetrieveProfileFacialImageValidationUrl = (imageId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/profile-facial/${imageId}/validation`;
};

/**
 * @summary Retrieve the validation result for a profile facial image
 */
export const retrieveProfileFacialImageValidation = async (imageId: string, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayProfileFacialImageValidation> => {
  return retrieveData<DisplayProfileFacialImageValidation>(getRetrieveProfileFacialImageValidationUrl(imageId), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveProfileFacialImageValidationQueryKey = (imageId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/profile-facial/${imageId}/validation`] as const;
};
export const getRetrieveProfileFacialImageValidationQueryOptions = <TData = Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveProfileFacialImageValidationQueryKey(imageId);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>> = ({
    signal
  }) => retrieveProfileFacialImageValidation(imageId, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: imageId !== null && imageId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveProfileFacialImageValidationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>>;
export type RetrieveProfileFacialImageValidationQueryError = ErrorType<unknown>;
export function useRetrieveProfileFacialImageValidation<TData = Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveProfileFacialImageValidation<TData = Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveProfileFacialImageValidation<TData = Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError = ErrorType<unknown>>(imageId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveProfileFacialImageValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve the validation result for a profile facial image
 */

export function useRetrieveProfileFacialImageValidation(imageId, options, queryClient) {
  const $ = _c(6);
  let t0;
  if ($[0] !== imageId || $[1] !== options) {
    t0 = getRetrieveProfileFacialImageValidationQueryOptions(imageId, options);
    $[0] = imageId;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[3] !== query || $[4] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[3] = query;
    $[4] = queryOptions.queryKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export const getUploadWellnessBodyPhotoUrl = (assessmentId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/platforms/${platformId}/wellness-body-photo`;
};

/**
 * @summary Upload a wellness body photo for an Ageless Assessment
 */
export const uploadWellnessBodyPhoto = async (assessmentId: string, platformId: string, uploadWellnessBodyPhotoBody?: UploadWellnessBodyPhotoBody, options?: Parameters<typeof retrieveData>[1]): Promise<UploadWellnessBodyPhotoResponse> => {
  const formData = new FormData();
  if (uploadWellnessBodyPhotoBody?.File !== undefined) {
    formData.append(`File`, uploadWellnessBodyPhotoBody.File);
  }
  return retrieveData<UploadWellnessBodyPhotoResponse>(getUploadWellnessBodyPhotoUrl(assessmentId, platformId), {
    ...options,
    method: "POST",
    body: formData
  });
};
export const getUploadWellnessBodyPhotoMutationKey = () => ["uploadWellnessBodyPhoto"] as const;
export const getUploadWellnessBodyPhotoMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof uploadWellnessBodyPhoto>>, TError, UploadWellnessBodyPhotoMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof uploadWellnessBodyPhoto>>, TError, UploadWellnessBodyPhotoMutationVariables, TContext> => {
  const mutationKey = getUploadWellnessBodyPhotoMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadWellnessBodyPhoto>>, UploadWellnessBodyPhotoMutationVariables> = props => {
    const {
      assessmentId,
      platformId,
      data
    } = props ?? {};
    return uploadWellnessBodyPhoto(assessmentId, platformId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UploadWellnessBodyPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadWellnessBodyPhoto>>>;
export type UploadWellnessBodyPhotoMutationBody = BodyType<UploadWellnessBodyPhotoBody> | undefined;
export type UploadWellnessBodyPhotoMutationError = ErrorType<unknown>;
export type UploadWellnessBodyPhotoMutationVariables = {
  assessmentId: string;
  platformId: string;
  data?: BodyType<UploadWellnessBodyPhotoBody>;
};

/**
 * @summary Upload a wellness body photo for an Ageless Assessment
 */
export const useUploadWellnessBodyPhoto = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUploadWellnessBodyPhotoMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRetrieveWellnessBodyPhotoValidationUrl = (photoId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/wellness-body-photo/${photoId}/validation`;
};

/**
 * @summary Retrieve the validation result for a wellness body photo
 */
export const retrieveWellnessBodyPhotoValidation = async (photoId: string, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayWellnessBodyPhotoValidation> => {
  return retrieveData<DisplayWellnessBodyPhotoValidation>(getRetrieveWellnessBodyPhotoValidationUrl(photoId), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveWellnessBodyPhotoValidationQueryKey = (photoId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/wellness-body-photo/${photoId}/validation`] as const;
};
export const getRetrieveWellnessBodyPhotoValidationQueryOptions = <TData = Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError = ErrorType<unknown>>(photoId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveWellnessBodyPhotoValidationQueryKey(photoId);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>> = ({
    signal
  }) => retrieveWellnessBodyPhotoValidation(photoId, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: photoId !== null && photoId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveWellnessBodyPhotoValidationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>>;
export type RetrieveWellnessBodyPhotoValidationQueryError = ErrorType<unknown>;
export function useRetrieveWellnessBodyPhotoValidation<TData = Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError = ErrorType<unknown>>(photoId: string, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWellnessBodyPhotoValidation<TData = Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError = ErrorType<unknown>>(photoId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWellnessBodyPhotoValidation<TData = Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError = ErrorType<unknown>>(photoId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessBodyPhotoValidation>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve the validation result for a wellness body photo
 */

export function useRetrieveWellnessBodyPhotoValidation(photoId, options, queryClient) {
  const $ = _c(6);
  let t0;
  if ($[0] !== options || $[1] !== photoId) {
    t0 = getRetrieveWellnessBodyPhotoValidationQueryOptions(photoId, options);
    $[0] = options;
    $[1] = photoId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[3] !== query || $[4] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[3] = query;
    $[4] = queryOptions.queryKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export const getConfirmWellnessPhotoCaptureUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/wellness-photo-capture/confirm`;
};

/**
 * @summary Confirm wellness photo capture for an assessment, triggering wellness preview generation.
 */
export const confirmWellnessPhotoCapture = async (assessmentId: string, confirmWellnessPhotoCaptureRequest?: ConfirmWellnessPhotoCaptureRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getConfirmWellnessPhotoCaptureUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(confirmWellnessPhotoCaptureRequest)
  });
};
export const getConfirmWellnessPhotoCaptureMutationKey = () => ["confirmWellnessPhotoCapture"] as const;
export const getConfirmWellnessPhotoCaptureMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof confirmWellnessPhotoCapture>>, TError, ConfirmWellnessPhotoCaptureMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof confirmWellnessPhotoCapture>>, TError, ConfirmWellnessPhotoCaptureMutationVariables, TContext> => {
  const mutationKey = getConfirmWellnessPhotoCaptureMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmWellnessPhotoCapture>>, ConfirmWellnessPhotoCaptureMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return confirmWellnessPhotoCapture(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type ConfirmWellnessPhotoCaptureMutationResult = NonNullable<Awaited<ReturnType<typeof confirmWellnessPhotoCapture>>>;
export type ConfirmWellnessPhotoCaptureMutationBody = BodyType<ConfirmWellnessPhotoCaptureRequest> | undefined;
export type ConfirmWellnessPhotoCaptureMutationError = ErrorType<unknown>;
export type ConfirmWellnessPhotoCaptureMutationVariables = {
  assessmentId: string;
  data?: BodyType<ConfirmWellnessPhotoCaptureRequest>;
};

/**
 * @summary Confirm wellness photo capture for an assessment, triggering wellness preview generation.
 */
export const useConfirmWellnessPhotoCapture = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getConfirmWellnessPhotoCaptureMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getDeclineWellnessForAssessmentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/wellness/decline`;
};

/**
 * @summary Record that the taker chose to finish the combined flow without its wellness part — from the Next Steps
choice or from "Skip for now" on the body photo.
 */
export const declineWellnessForAssessment = async (assessmentId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getDeclineWellnessForAssessmentUrl(assessmentId), {
    ...options,
    method: "POST"
  });
};
export const getDeclineWellnessForAssessmentMutationKey = () => ["declineWellnessForAssessment"] as const;
export const getDeclineWellnessForAssessmentMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof declineWellnessForAssessment>>, TError, DeclineWellnessForAssessmentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof declineWellnessForAssessment>>, TError, DeclineWellnessForAssessmentMutationVariables, TContext> => {
  const mutationKey = getDeclineWellnessForAssessmentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineWellnessForAssessment>>, DeclineWellnessForAssessmentMutationVariables> = props => {
    const {
      assessmentId
    } = props ?? {};
    return declineWellnessForAssessment(assessmentId, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type DeclineWellnessForAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof declineWellnessForAssessment>>>;
export type DeclineWellnessForAssessmentMutationError = ErrorType<ProblemDetails>;
export type DeclineWellnessForAssessmentMutationVariables = {
  assessmentId: string;
};

/**
 * @summary Record that the taker chose to finish the combined flow without its wellness part — from the Next Steps
choice or from "Skip for now" on the body photo.
 */
export const useDeclineWellnessForAssessment = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getDeclineWellnessForAssessmentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRetrieveComprehensiveTreatmentAnalysisUrl = (assessmentId: string, params?: RetrieveComprehensiveTreatmentAnalysisParams) => {
  const normalizedParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });
  const stringifiedParams = normalizedParams.toString();
  return stringifiedParams.length > 0 ? `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/analysis?${stringifiedParams}` : `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/analysis`;
};

/**
 * @summary Retrieve the comprehensive treatment analysis for an assessment
 */
export const retrieveComprehensiveTreatmentAnalysis = async (assessmentId: string, params?: RetrieveComprehensiveTreatmentAnalysisParams, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayComprehensiveTreatmentAnalysisResponse> => {
  return retrieveData<DisplayComprehensiveTreatmentAnalysisResponse>(getRetrieveComprehensiveTreatmentAnalysisUrl(assessmentId, params), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveComprehensiveTreatmentAnalysisQueryKey = (assessmentId: string, params?: RetrieveComprehensiveTreatmentAnalysisParams) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/analysis`, ...(params ? [params] : [])] as const;
};
export const getRetrieveComprehensiveTreatmentAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError = ErrorType<unknown>>(assessmentId: string, params?: RetrieveComprehensiveTreatmentAnalysisParams, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveComprehensiveTreatmentAnalysisQueryKey(assessmentId, params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>> = ({
    signal
  }) => retrieveComprehensiveTreatmentAnalysis(assessmentId, params, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveComprehensiveTreatmentAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>>;
export type RetrieveComprehensiveTreatmentAnalysisQueryError = ErrorType<unknown>;
export function useRetrieveComprehensiveTreatmentAnalysis<TData = Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError = ErrorType<unknown>>(assessmentId: string, params: undefined | RetrieveComprehensiveTreatmentAnalysisParams, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveComprehensiveTreatmentAnalysis<TData = Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError = ErrorType<unknown>>(assessmentId: string, params?: RetrieveComprehensiveTreatmentAnalysisParams, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveComprehensiveTreatmentAnalysis<TData = Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError = ErrorType<unknown>>(assessmentId: string, params?: RetrieveComprehensiveTreatmentAnalysisParams, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveTreatmentAnalysis>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve the comprehensive treatment analysis for an assessment
 */

export function useRetrieveComprehensiveTreatmentAnalysis(assessmentId, params, options, queryClient) {
  const $ = _c(7);
  let t0;
  if ($[0] !== assessmentId || $[1] !== options || $[2] !== params) {
    t0 = getRetrieveComprehensiveTreatmentAnalysisQueryOptions(assessmentId, params, options);
    $[0] = assessmentId;
    $[1] = options;
    $[2] = params;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[4] !== query || $[5] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[4] = query;
    $[5] = queryOptions.queryKey;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export const getRetrieveComprehensiveLashBrowAnalysisUrl = (assessmentId: string, params?: RetrieveComprehensiveLashBrowAnalysisParams) => {
  const normalizedParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });
  const stringifiedParams = normalizedParams.toString();
  return stringifiedParams.length > 0 ? `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/lash-brow-analysis?${stringifiedParams}` : `https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/lash-brow-analysis`;
};

/**
 * @summary Retrieve the comprehensive lash & brow analysis for an assessment
 */
export const retrieveComprehensiveLashBrowAnalysis = async (assessmentId: string, params?: RetrieveComprehensiveLashBrowAnalysisParams, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayComprehensiveLashBrowAnalysisResponse> => {
  return retrieveData<DisplayComprehensiveLashBrowAnalysisResponse>(getRetrieveComprehensiveLashBrowAnalysisUrl(assessmentId, params), {
    ...options,
    method: "GET"
  });
};
export const getRetrieveComprehensiveLashBrowAnalysisQueryKey = (assessmentId: string, params?: RetrieveComprehensiveLashBrowAnalysisParams) => {
  return [`https://admin.ageless.ai/api/v1/ageless/imaging/assessments/${assessmentId}/lash-brow-analysis`, ...(params ? [params] : [])] as const;
};
export const getRetrieveComprehensiveLashBrowAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError = ErrorType<ProblemDetails>>(assessmentId: string, params?: RetrieveComprehensiveLashBrowAnalysisParams, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRetrieveComprehensiveLashBrowAnalysisQueryKey(assessmentId, params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>> = ({
    signal
  }) => retrieveComprehensiveLashBrowAnalysis(assessmentId, params, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type RetrieveComprehensiveLashBrowAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>>;
export type RetrieveComprehensiveLashBrowAnalysisQueryError = ErrorType<ProblemDetails>;
export function useRetrieveComprehensiveLashBrowAnalysis<TData = Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError = ErrorType<ProblemDetails>>(assessmentId: string, params: undefined | RetrieveComprehensiveLashBrowAnalysisParams, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveComprehensiveLashBrowAnalysis<TData = Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError = ErrorType<ProblemDetails>>(assessmentId: string, params?: RetrieveComprehensiveLashBrowAnalysisParams, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveComprehensiveLashBrowAnalysis<TData = Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError = ErrorType<ProblemDetails>>(assessmentId: string, params?: RetrieveComprehensiveLashBrowAnalysisParams, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveComprehensiveLashBrowAnalysis>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve the comprehensive lash & brow analysis for an assessment
 */

export function useRetrieveComprehensiveLashBrowAnalysis(assessmentId, params, options, queryClient) {
  const $ = _c(7);
  let t0;
  if ($[0] !== assessmentId || $[1] !== options || $[2] !== params) {
    t0 = getRetrieveComprehensiveLashBrowAnalysisQueryOptions(assessmentId, params, options);
    $[0] = assessmentId;
    $[1] = options;
    $[2] = params;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[4] !== query || $[5] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[4] = query;
    $[5] = queryOptions.queryKey;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}